import { Star } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import SectionHeading from "@/components/SectionHeading";
import SEO from "@/components/SEO";

export default function Reviews() {
  const { reviews } = useContent();
  const avg = reviews.length ? (reviews.reduce((a, r) => a + r.rating, 0) / reviews.length).toFixed(1) : "5.0";

  return (
    <div data-testid="reviews-page" className="pt-32 pb-24">
      <SEO path="/reviews" title="Customer Reviews & Testimonials"
        description="Read genuine reviews from architects, builders, fabricators and homeowners across India who buy aluminium sections, ACP and hardware from Victory Aluminium, Chennai." />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-14">
        <SectionHeading eyebrow="Trusted by Our Customers" title="Reviews from architects, builders, and homeowners."
          sub="An authentic view of how clients across India experience working with Victory Aluminium." />
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-12">
        <div className="bg-white border border-[#E5E7EB] p-8 flex flex-col md:flex-row md:items-center gap-8">
          <div>
            <div className="font-display text-6xl text-[#1A1A1A]">{avg}</div>
            <div className="flex items-center gap-0.5 mt-2 text-[#D4AF37]">
              {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="w-5 h-5 fill-[#D4AF37]" />)}
            </div>
            <div className="text-sm text-[#6B7280] mt-2">{reviews.length} verified reviews</div>
          </div>
          <div className="md:border-l md:border-[#E5E7EB] md:pl-8 flex-1">
            <div className="font-display text-2xl">As seen on <span className="text-[#4285F4]">Google</span></div>
            <p className="text-sm text-[#4B5563] mt-2 max-w-xl">Reviews represent independent client feedback shared via Google. Reach out and we&apos;d be glad to share project references.</p>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <article key={r.id} data-testid={`review-${r.id}`} className="bg-white border border-[#E5E7EB] p-7 hover:border-[#D4AF37] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#1A1A1A] text-[#D4AF37] flex items-center justify-center font-display">{r.avatar_initials}</div>
                <div>
                  <div className="font-semibold text-sm">{r.name}</div>
                  <div className="text-xs text-[#6B7280]">{r.profession}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mt-4 text-[#D4AF37]">
                {Array.from({ length: r.rating }).map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D4AF37]" />)}
              </div>
              <p className="mt-4 text-sm text-[#4B5563] leading-relaxed">{r.text}</p>
              <div className="mt-5 flex items-center justify-between text-[10px] uppercase tracking-widest text-[#9CA3AF]">
                <span>{r.relative_time}</span>
                <span className="font-semibold text-[#4285F4]">G · Google</span>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
